import React, { useEffect, useState } from 'react';
interface MasteryRingProps {
  value: number; // 0-100
  size?: number;
  strokeWidth?: number;
  color?: 'indigo' | 'emerald' | 'rose' | 'amber';
  showLabel?: boolean;
  className?: string;
}
export function MasteryRing({
  value,
  size = 48,
  strokeWidth = 4,
  color = 'indigo',
  showLabel = true,
  className = ''
}: MasteryRingProps) {
  const [animatedValue, setAnimatedValue] = useState(0);
  useEffect(() => {
    // Small delay to ensure animation triggers after mount
    const timer = setTimeout(() => setAnimatedValue(value), 50);
    return () => clearTimeout(timer);
  }, [value]);
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - animatedValue / 100 * circumference;
  const colorClasses = {
    indigo: 'text-indigo-500',
    emerald: 'text-emerald-500',
    rose: 'text-rose-500',
    amber: 'text-amber-500'
  };
  return <div className={`relative inline-flex items-center justify-center ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-4549">
      <svg className="transform -rotate-90 w-full h-full" viewBox={`0 0 ${size} ${size}`} data-id="element-4550">
        {/* Background track */}
        <circle className="text-slate-100" strokeWidth={strokeWidth} stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-4551" />
        {/* Progress ring */}
        <circle className={`${colorClasses[color]} transition-all duration-1000 ease-out`} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap="round" stroke="currentColor" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-4552" />
      </svg>

      {showLabel && <div className="absolute inset-0 flex items-center justify-center" data-id="element-4553">
          <span className="text-xs font-black text-slate-700" data-id="element-4554">
            {value}
            <span className="text-[10px] text-slate-400" data-id="element-4555">%</span>
          </span>
        </div>}
    </div>;
}